import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

// Type definition for baggage item from API
interface BaggageAllowance {
    unit: string | null;
    qty: number;
    pieceInfo: number;
    description: string;
}

interface BaggageItem {
    baggageType: 'CARRY_ON' | 'CHECK_IN';
    baggageTypeDisplayText: string;
    baggageDescription: string | null;
    permitted: boolean;
    baggageAllowances: BaggageAllowance[];
}

interface SimpleBaggageTableProps {
    baggage: BaggageItem[];
}

const SimpleBaggageTable: React.FC<SimpleBaggageTableProps> = ({ baggage }) => {
    if (!baggage || baggage.length === 0) {
        return null;
    }

    // Find cabin and check-in baggage
    const cabinBag = baggage.find((bag: BaggageItem) => bag.baggageType === 'CARRY_ON');
    const checkInBag = baggage.find((bag: BaggageItem) => bag.baggageType === 'CHECK_IN');

    // Helper function to remove parentheses/braces from text
    const removeBraces = (text: string | null) => {
        return text?.replace(/[()]/g, '').trim() || text || '';
    };

    // Extract baggage text - use baggageDescription or baggageTypeDisplayText
    const getCabinBaggageText = () => {
        if (cabinBag) {
            const text = cabinBag.baggageDescription || cabinBag.baggageTypeDisplayText || '-';
            return removeBraces(text);
        }
        return '-';
    };

    const getCheckInBaggageText = () => {
        if (checkInBag) {
            const text = checkInBag.baggageDescription || checkInBag.baggageTypeDisplayText || '-';
            return removeBraces(text);
        }
        return '-';
    };

    // For simplicity, we'll show the same baggage for all passenger types
    // since the API response doesn't differentiate
    const baggageText = {
        cabin: getCabinBaggageText(),
        checkIn: getCheckInBaggageText()
    };

    return (
        <Box sx={{ px: 2, py: 2, borderBottom: '1px solid #e0e0e0' }}>
            
            <TableContainer>
                <Table size="small" sx={{ 
                    '& .MuiTableCell-root': { 
                        border: '1px solid #e0e0e0',
                        padding: '8px 12px',
                        fontSize: '13px',
                        borderRadius : '4px'
                    }
                }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>
                                Cabin
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>
                                Check-in
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{baggageText.cabin}</TableCell>
                            <TableCell>{baggageText.checkIn}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default SimpleBaggageTable;